import React from 'react';
import PropTypes from 'prop-types';

const TagTeam = props => {

    const { bckgColor, subtitle } = props;

    return (
        <article className="text-center">
            <span className="px-3 py-2 text-white tag-team" style={{ background: bckgColor }}>{subtitle}</span>
        </article>
    )
}

export default TagTeam;

TagTeam.propTypes = {
    bckgColor: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired
}
